import {Page} from "../../../Common/Component/Page/Page";
import {Alert, Card, Col, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {LoginLogo} from "../../../Common/Component/Logo/LoginLogo";
import {useState} from "react";
import LoginService from "../LoginService";
import Notify from "../../../Common/Notify/Notify";
import {Link, useNavigate} from "react-router-dom";
import {LoadingButton} from "../../../Common/Component/Loading/LoadingButton";


export default function RecoveryPassword() {

    const [isLoading, setIsLoading] = useState(false);
    const [username, setUsername] = useState(null);
    const [userCode, setUserCode] = useState(null);

    const [newPassword, setNewPassword] = useState('');
    const [newRePassword, setRePassword] = useState('');

    const [isSuccess, setIsSuccess] = useState(false);

    const navigate = useNavigate();


    const doSubmit = (e) => {
        if (isSuccess) {
            return resetPassword(e)
        }
        return recoveryPassword(e);
    }
    const recoveryPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const loginService = new LoginService();
            await loginService.recoveryPassword(username);
            setIsSuccess(true);
            Notify.success('Código envido por email!');
        } catch (e) {
            Notify.error('Falha ao resetar senha', e);
        } finally {
            setIsLoading(false);
        }
        return false;
    }

    const resetPassword = async (e) => {
        e.preventDefault();

        if (newPassword.length >= 6 && newPassword !== newRePassword) {
            Notify.warning("Senhas não conferem ou não estão no padrão!");
            return;
        }
        setIsLoading(true);
        try {
            const loginService = new LoginService();
            await loginService.changePassword({email: username, code: userCode, password: newPassword});
            Notify.success('Senha resetada!');
            navigate('/entrar');
        } catch (e) {
            Notify.error('Falha ao resetar senha', e);
        } finally {
            setIsLoading(false);
        }
        return false;
    }

    const orientationMessage = () => (<>
        <Alert variant="primary">
            Você deve receber dentro de instantes um e-email, nele você vai encontrar um código para recuperar sua
            senha!
            <br/>
            Verifique sua caixa de entrara ou sua caixa de spam!
        </Alert>
    </>);

    const startMessage = () => {
        return <Alert variant="dark">
            Informe abaixo seu e-mail!<br/>
            Você receberá um código nele para recuperar sua senha.
        </Alert>

    }

    return <Page>

        <LoginLogo/>

        <Card className="col-sm-12 col-md-6 col-xl-4 offset-xl-4 offset-md-3 p-0">
            <Card.Header as="h5" className="text-center">
                Recuperar Senha
            </Card.Header>
            <Card.Body>
                {isSuccess ? orientationMessage() : startMessage()}

                <Form onSubmit={doSubmit}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>E-mail</Form.Label>
                        <InputGroup className="mb-3">
                            <FormControl name="login-email" required disabled={isSuccess}
                                         type="email" placeholder="E-mail de autenticação"
                                         onChange={e => setUsername(e.target.value)}/>
                            <InputGroup.Text>
                                <i className="bi bi-envelope-fill"/>
                            </InputGroup.Text>
                        </InputGroup>

                        {isSuccess && <>
                            <InputGroup className="mb-3">
                                <FormControl name="login-code" required
                                             type="number" placeholder="Código recebido por email"
                                             onChange={e => setUserCode(e.target.value)}/>
                                <InputGroup.Text>
                                    <i className="bi bi-envelope-fill"/>
                                </InputGroup.Text>
                            </InputGroup>


                            <InputGroup className="mb-3">
                                <FormControl name="password" required
                                             type="password" placeholder="Digite sua nova senha"
                                             onChange={e => setNewPassword(e.target.value)}/>
                                <InputGroup.Text>
                                    <i className="bi bi-envelope-fill"/>
                                </InputGroup.Text>
                            </InputGroup>

                            <InputGroup className="mb-3">
                                <FormControl name="repassword" required
                                             type="password" placeholder="Digite novamente sua senha"
                                             onChange={e => setRePassword(e.target.value)}/>
                                <InputGroup.Text>
                                    <i className="bi bi-envelope-fill"/>
                                </InputGroup.Text>
                            </InputGroup>
                        </>}
                    </Form.Group>


                    <div className="d-grid gap-2">
                        <LoadingButton isLoading={isLoading} title="Recuperar senha"
                                       text="Recuperar"/>
                    </div>
                </Form>

                <Row className="mt-3">
                    <Col sm={12} md={6}>
                        <Link to="/">Voltar</Link>
                    </Col>
                </Row>
            </Card.Body>


        </Card>
    </Page>
}
